import { reactive } from 'vue';

export const globalState = reactive({
  successMessage: '',
  isSuperAdmin: true,  
});